module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'y5ejtdp8',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
